import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "phone",
    standalone: false
})
export class PhonePipe implements PipeTransform {
  transform(tel: string, obfuscate = true): any | undefined {
    if (tel) {
      const value = tel.toString().replace(/\D/g, "");
      let phoneFormat = "";

      if (obfuscate) {
        phoneFormat = this._handleObfuscateTel(tel);
      } else {
        if (value.length > 12) {
          phoneFormat = value.replace(
            /(\d{2})?(\d{2})?(\d{5})?(\d{4})/,
            "+$1 ($2) $3-$4",
          ); //NOSONAR
        } else if (value.length > 11) {
          phoneFormat = value.replace(
            /(\d{2})?(\d{2})?(\d{5})?(\d{3})/,
            "+$1 ($2) $3-$4",
          ); // NOSONAR
        } else if (value.length > 10) {
          phoneFormat = value.replace(/(\d{2})?(\d{5})?(\d{4})/, "($1) $2-$3"); // NOSONAR
        } else if (value.length > 9) {
          phoneFormat = value.replace(/(\d{2})?(\d{4})?(\d{4})/, "($1) $2-$3"); // NOSONAR
        } else if (value.length > 5) {
          phoneFormat = value.replace(
            /^(\d{2})?(\d{4})?(\d{0,4})/,
            "($1) $2-$3",
          ); // NOSONAR
        } else if (value.length > 1) {
          phoneFormat = value.replace(/^(\d{2})?(\d{0,5})/, "($1) $2"); // NOSONAR
        } else {
          phoneFormat = value.replace(/^(\d*)/, "($1");
        }
      }
      return phoneFormat;
    }
  }
  private _handleObfuscateTel(value: string): string {
    if (value.length === 6) {
      return value.replace(/(\d{2})?(\d{4})/, "($1) *****-$2"); // NOSONAR
    } else if (value.length === 11) {
      return value.replace(/(\d{2})?(\d{5})/, "($1) *****-"); // NOSONAR
    } else {
      return "";
    }
  }
}
